module.exports = __webpack_public_path__ + "media/images/sponsor/ms-icon-310x310-47dcb1613244c37c9a520c8145d74b45.png";